import { type FunctionalComponent, h } from '@stencil/core';
import type { PaginationStrategyService } from '../../strategies/PaginationStrategyService';
import type { ISearchPaginationTag } from '../search-tab/subcomponents/types/subcomponents-types.type';
import { PAGINATION_TYPE } from '../../strategies/utils/variables';

export const SearchPaginationTag: FunctionalComponent<ISearchPaginationTag> = ({
  ...props
}) => {
    const paginationStrategy: PaginationStrategyService =
    props.strategies.for(PAGINATION_TYPE);
    const Tag = paginationStrategy.makePagination();

    return <Tag {...props} />;
};
